import React from 'react';
const ServiceBoxTiny = ({isHaveBadge, badgeText, actionName, backgroundColorProperty, isBold, callback}) => {
  return (
    <>
      <div className='serviceBoxTiny' onClick={() => callback()}>
        <div
          className='container-block-item'
          style={backgroundColorProperty ? {backgroundColor: backgroundColorProperty} : {backgroundColor: '#fff'}}>
          <div className='item-title w-100' style={isBold ? {fontWeight: 600} : {fontWeight: 'unset'}}>
            {actionName}
          </div>
          {isHaveBadge && <div className='item-badge'>{badgeText}</div>}
        </div>
      </div>
    </>
  );
};
export default ServiceBoxTiny;
